import React from "react";
import { Form } from "react-bootstrap";


const TextField = ({name, props}) => {
    // console.log('Textfield', {name, props});
    const {
        variables,
        handleChange,
        validateField = () => {},
        fieldSettings, 
        fieldErrors, 
        } = props
        const {label, required, autoFocus, toolTip, type, visible, disabled, placeholder} = fieldSettings[name];
        const value = variables[name];
        

    const maxLength = fieldSettings[name]?.validation?.maxLength || 0;
    const handleChangeLocal = e => {
        const len = e.target?.value?.length || 0;
        if(!maxLength || len <= maxLength)handleChange(e);
    }

    if (visible === false) return null;
    return(
        <Form.Group size="lg" controlId={name} >
            {/* <Form.Label style={{color:"#1a4a70"}} className ="pt-1 px-1" >{label}{required? ' * ':' '} */}
            <Form.Label  className ="pt-1 px-1" >{label}{required? ' * ':' '}
            { fieldErrors[name]?<small className="text-danger" > - {fieldErrors[name]}</small>:null}
            </Form.Label>
            <Form.Control 
                style = {fieldErrors[name] ? {border:"2px solid red", backgroundColor:"rgb(255,235,235)"}:{}}
                name={name} 
                disabled={disabled}
                type={type} 
                key={name} 
                autoFocus={autoFocus}
                // fieldType={fieldType}
                value={value}
                required = {required}
                placeholder={placeholder || `${name} (string)`}
                onChange={e => handleChangeLocal(e)} 
                onBlur={e => validateField(e)}
            />
            {toolTip?<p><small className="text-black p-1" >{toolTip}</small></p>:null}
        </Form.Group>
    )
}
export default TextField;
